import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { profileAPI } from '../api/auth';
import OfficialBadge from '../components/OfficialBadge';

const Search = () => {
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    const loadAllUsers = async () => {
      try {
        const data = await profileAPI.getAllUsers(token);
        setAllUsers(data);
        setUsers(data);
      } catch (err) {
        console.error('Failed to load users:', err);
      }
    };

    loadAllUsers();
  }, [navigate]);

  const handleSearch = async (searchQuery) => {
    setQuery(searchQuery);

    if (searchQuery.length < 2) {
      setUsers(allUsers);
      setError('');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const token = localStorage.getItem('token');
      const results = await profileAPI.searchUsers(token, searchQuery);
      setUsers(results);
    } catch (err) {
      setError('Ошибка поиска');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <div className="flex items-center gap-4 mb-4">
            <button onClick={() => navigate('/messenger')} className="text-gray-600 hover:text-gray-800">
              ← Назад
            </button>
            <h1 className="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-blue-600">Поиск пользователей</h1>
          </div>
          <input
            type="text"
            value={query}
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Поиск по @username..."
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            data-testid="search-input"
          />
        </div>
      </div>

      <div className="max-w-4xl mx-auto p-4">
        {error && <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">{error}</div>}
        {loading && <div className="text-center py-8"><div className="text-gray-600">Поиск...</div></div>}

        {!loading && users.length === 0 && (
          <div className="text-center py-8">
            <div className="text-gray-600">Пользователи не найдены</div>
          </div>
        )}

        <div className="space-y-3">
          {users.map((user) => (
            <div
              key={user.id}
              onClick={() => navigate(`/profile/${user.username}`)}
              className="bg-white rounded-lg shadow p-4 flex items-center gap-4 cursor-pointer hover:shadow-lg transition"
              data-testid={`user-item-${user.username}`}
            >
              <div className="w-16 h-16 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full flex items-center justify-center text-white text-2xl font-bold">
                {user.username.charAt(0).toUpperCase()}
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="font-bold text-lg">@{user.username}</h3>
                  <OfficialBadge username={user.username} />
                </div>
                {user.bio && <p className="text-gray-600 text-sm line-clamp-2">{user.bio}</p>}
              </div>
              <div className="text-purple-600">→</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Search;
